import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const addTicketEvent = createAsyncThunk("AgentRequests/addTicketEvent", async (data, thunkAPI) => {
  let { schema} = data;
  try {
    const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}api/agent-ticket/event/${data.ticketId}`, schema, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return resp.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
